import { Col } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { IconSize, IconType, IconWrap, semanticTheme } from '@tools/ui/dime';
import useCopy from '@tools/ui-hooks/useCopy.hook';

type IProps = {
  text: string;
  space?: number;
  color?: string;
  'data-testid'?: string;
};

const StyledIconWrap = styled(IconWrap)`
  color: ${({ color }) => color};
`;

const SpacedCol = styled(Col)<{ space?: number }>`
  display: inline-block;
  padding-left: ${({ space = 0 }) => space || 10}px;
`;
const ApproveIcon = styled(IconWrap)`
  color: ${semanticTheme.dime.colors.icon.success};
`;

const CopyToClipboard: React.FC<React.PropsWithChildren<IProps>> = ({
  text,
  space,
  color = semanticTheme.dime.colors.icon.brand
}) => {
  const { copy, copied } = useCopy();
  return (
    <SpacedCol
      space={space}
      data-testid="copy-to-clipboard"
      style={{ cursor: 'pointer' }}
      onClick={(event) => {
        event.stopPropagation();
        copy(text);
      }}
    >
      {copied ? (
        <ApproveIcon type={IconType.Approve} size={IconSize.Small} />
      ) : (
        <StyledIconWrap
          type={IconType.Copy}
          size={IconSize.Small}
          color={color}
        />
      )}
    </SpacedCol>
  );
};

export default CopyToClipboard;
